import React from "react";
import { Container, Box, Link } from "@mui/material";
import BottomToolbar from "./BottomToolbar";
import PageHeader from "./PageHeader";
import { T } from "./Translate";
import { pageContentSx } from "../pageLayout";

const PrivacyPolicy = () => {
  return (
    <Container maxWidth={false} disableGutters sx={pageContentSx}>
      <PageHeader title={<T>Política de Privacidad</T>} />
      <Container sx={{ mt: "16px", mb: 16 }}>
        <Container
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            width: "100%",
            textAlign: "left",
          }}
        >
          <Box>
            <h1><T>Política de Privacidad de Notiline</T></h1>

            <p>
              <T>Esta política explica qué información recopila Notiline, para qué la usamos
              y qué opciones tenés sobre tus datos. Notiline es una app operada por Dapur
              Tecnología para publicar y descubrir ofertas, eventos, tiendas, vehículos y
              propiedades/viajes, y para hacer y recibir pedidos de comida y súper.</T>
            </p>

            <h2><T>Información que recopilamos</T></h2>
            <p><T>Recopilamos la información necesaria para que la app funcione:</T></p>
            <ul>
              <li>
                <T>Datos de cuenta: email, nombre y apellido, nombre de usuario, número de
                documento y teléfono que ingresás al registrarte.</T>
              </li>
              <li>
                <T>Datos de perfil: foto de perfil, localidad y, si publicás una tienda,
                autos, propiedades o eventos, la información de esas publicaciones.</T>
              </li>
              <li>
                <T>Ubicación: usamos tu ubicación aproximada (por GPS o por IP) para
                mostrarte ofertas, eventos y tiendas cercanas.</T>
              </li>
              <li>
                <T>Actividad en la app: ofertas guardadas, tiendas que seguís, mensajes de
                chat, comentarios, preguntas y respuestas, y códigos de cupón escaneados.</T>
              </li>
              <li>
                <T>Pagos: si te suscribís o comprás una entrada/cupón, el pago se procesa
                directamente por PayPal. Notiline no almacena números de tarjeta ni datos
                bancarios.</T>
              </li>
              <li>
                <T>Pedidos que hacés: productos, notas, total, forma de pago, teléfono y, si es
                con envío, tu dirección y el punto de entrega, que es tu ubicación exacta si
                elegís usar el GPS. Notiline no procesa estos pagos: se hacen en efectivo o por
                transferencia directamente al local. Tu dirección y tu teléfono también quedan
                guardados en tu dispositivo para el próximo pedido.</T>
              </li>
              <li>
                <T>Locales de Pedidos: datos del local, menú, horarios, alias de transferencia y
                pedidos recibidos. Si el local elige compartir la ubicación durante un envío,
                guardamos la ubicación en tiempo real del celular del repartidor, y la última
                posición queda registrada en el pedido.</T>
              </li>
              <li>
                <T>Notificaciones: un token de dispositivo para enviarte notificaciones push
                sobre ofertas, mensajes y novedades de tu cuenta.</T>
              </li>
              <li>
                <T>Registros de acceso: fecha, hora, ubicación aproximada y país desde el que
                iniciás sesión, por seguridad.</T>
              </li>
            </ul>

            <h2><T>Cómo usamos tu información</T></h2>
            <ul>
              <li><T>Mostrarte ofertas, eventos, tiendas, autos y propiedades relevantes según tu ubicación e intereses.</T></li>
              <li><T>Procesar suscripciones, compras de entradas y comisiones a través de PayPal.</T></li>
              <li><T>Gestionar los pedidos: enviarlos al local, mostrar su estado y su recorrido en el mapa, y confirmar la entrega con un código.</T></li>
              <li><T>Enviarte notificaciones sobre tu actividad (mensajes, respuestas, ofertas guardadas, pedidos, novedades).</T></li>
              <li><T>Detectar accesos sospechosos y proteger tu cuenta, incluyendo la verificación en dos pasos.</T></li>
              <li><T>Brindarte soporte cuando nos escribís o usás el asistente de ayuda.</T></li>
              <li><T>Mejorar la app y prevenir fraude, spam o abuso.</T></li>
            </ul>

            <h2><T>Con quién compartimos información</T></h2>
            <p>
              <T>No vendemos tu información. La compartimos únicamente cuando es necesario
              para operar Notiline:</T>
            </p>
            <ul>
              <li>
                <T>Con PayPal, para procesar pagos, suscripciones y reembolsos.</T>
              </li>
              <li>
                <T>Con Firebase/Google Cloud, nuestro proveedor de infraestructura, que
                almacena la base de datos, las imágenes y gestiona la autenticación y las
                notificaciones push.</T>
              </li>
              <li>
                <T>Con otros usuarios: tu nombre de usuario, foto de perfil y las
                publicaciones que hacés (ofertas, eventos, tienda, local, autos, propiedades) son
                visibles públicamente dentro de la app, como es esperable en un marketplace.</T>
              </li>
              <li>
                <T>Con el local al que le hacés un pedido: tu nombre, teléfono, dirección, punto
                de entrega, productos, notas y forma de pago, para que pueda prepararlo y
                entregarlo. Si el local comparte la ubicación del repartidor, el cliente de ese
                pedido la ve en el mapa mientras está en camino.</T>
              </li>
              <li>
                <T>Con servicios de mapas y rutas, como OpenStreetMap y OSRM, que reciben
                direcciones o coordenadas para ubicar el punto de entrega y dibujar el recorrido.
                Si el local usa el botón "Cómo llegar", el destino se abre en Google Maps.</T>
              </li>
              <li>
                <T>Cuando la ley lo requiera, o para proteger los derechos, la seguridad o la
                propiedad de Notiline y de sus usuarios.</T>
              </li>
            </ul>

            <h2><T>Seguridad de tu cuenta</T></h2>
            <p>
              <T>Podés activar la verificación en dos pasos desde Ajustes, que agrega un
              código de tu app autenticadora (o un código de respaldo) además de tu
              contraseña para iniciar sesión. Te recomendamos guardar tus códigos de
              respaldo en un lugar seguro: son la única forma de recuperar el acceso si
              perdés tu dispositivo con la app autenticadora.</T>
            </p>

            <h2><T>Tus derechos sobre tus datos</T></h2>
            <p>
              <T>Desde la sección de Ajustes y Editar Perfil podés actualizar tus datos de
              cuenta y de perfil en cualquier momento. Si querés eliminar tu cuenta o los
              datos que tenemos sobre vos, o tenés alguna consulta sobre esta política,
              escribinos a</T>{" "}
              <Link href="mailto:support@notiline.com">support@notiline.com</Link>.{" "}
              <T>Los pasos y qué datos se borran o se conservan están en</T>{" "}
              <Link href="/delete-account"><T>Eliminar cuenta</T></Link>.
            </p>
            <p>
              <T>Si eliminás tu cuenta, se borran tu local de Pedidos y su menú, y los pedidos
              que siguen en curso se cierran. Los pedidos que hiciste se conservan como registro
              de compra, sin tu nombre, dirección, teléfono, notas ni ubicaciones. Los que recibió
              tu local conservan su nombre, pero no su dirección, alias ni ubicación.</T>
            </p>

            <h2><T>Menores de edad</T></h2>
            <p>
              <T>Notiline no está dirigido a menores de 13 años y no recopilamos a sabiendas
              información de niños. Si creés que un menor nos proporcionó información
              personal, contactanos para eliminarla.</T>
            </p>

            <h2><T>Cambios a esta política</T></h2>
            <p>
              <T>Podemos actualizar esta Política de Privacidad para reflejar cambios en la
              app o en la normativa aplicable. Si hacemos cambios importantes, te avisaremos
              dentro de la app.</T>
            </p>

            <h2><T>Contacto</T></h2>
            <p>
              <T>Ante cualquier duda sobre esta Política de Privacidad, escribinos a</T>{" "}
              <Link href="mailto:support@notiline.com">support@notiline.com</Link>.
            </p>
          </Box>
        </Container>
      </Container>
      <BottomToolbar />
    </Container>
  );
};

export default PrivacyPolicy;
